import { gql } from "@apollo/client";

export const GET_ALL_ALERGIAS = gql`
  query AllAlergias {
    allAlergias {
        idAlergia
        descripcion
    }
}`;